import { type SearchSourceId } from "@/features/map/utils/buildSearchChain";
import {
  GEOSPACE_CHIBAN_TILE_LAYER_NAME,
  LEGAL_AFFAIRS_CHIBAN_TILE_LAYER_NAME,
  LEGAL_AFFAIRS_CHIBAN_MIN_ZOOM,
} from "@/features/map/components/CommonChibanTileLayer";
import { TRUSTART_CHIBAN_LAYER_NAME } from "@/features/map/components/layers/TrustartChibanTileLayer";
import { REGISTRATION_MAP_LAYER_NAME } from "@/features/map/components/mapLibre/layers/RegistrationMapTileLayer";
import {
  ZENRIN_BLUE_MAP_LAYER_NAME,
  ZENRIN_BLUE_MAP_MIN_ZOOM,
} from "@/features/map/components/layers/ZenrinBlueMapTileLayer";
import {
  GEOSPACE_CHIBAN_PANEL_MIN_ZOOM,
  REGISTRATION_MAP_PANEL_MIN_ZOOM,
  TRUSTART_CHIBAN_PANEL_MIN_ZOOM,
} from "@/features/map/constants/layerPanelZoom";

/** データソースに対応する表示レイヤーと、そのレイヤーが描画され始めるズーム。 */
export interface SearchSourceLayer {
  /** 乖離リカバリーで ON にするレイヤー名。 */
  layerName: string;
  /** このズーム未満だとレイヤーを ON にしても何も描画されない。 */
  minZoom: number;
}

/**
 * データソース → 表示レイヤーの対応。
 *
 * 非表示のソース（Tier 2）でヒットしたとき、利用者が「見ている地図」と「結果の出どころ」の
 * ずれを解消できるよう、該当レイヤーを ON にするために使う。
 *
 * minZoom は原則としてレイヤー側の定数を参照する。レイヤー実装の定数と実際の表示開始ズームが
 * 異なるものは、レイヤーパネルと共有している `constants/layerPanelZoom.ts` の値を使う。
 */
export const SEARCH_SOURCE_LAYER: Record<SearchSourceId, SearchSourceLayer> = {
  geospaceChiban: {
    layerName: GEOSPACE_CHIBAN_TILE_LAYER_NAME,
    minZoom: GEOSPACE_CHIBAN_PANEL_MIN_ZOOM,
  },
  geospaceLegalAffairs: {
    layerName: LEGAL_AFFAIRS_CHIBAN_TILE_LAYER_NAME,
    minZoom: LEGAL_AFFAIRS_CHIBAN_MIN_ZOOM,
  },
  trustartChiban: {
    layerName: TRUSTART_CHIBAN_LAYER_NAME,
    minZoom: TRUSTART_CHIBAN_PANEL_MIN_ZOOM,
  },
  registrationMap: {
    layerName: REGISTRATION_MAP_LAYER_NAME,
    minZoom: REGISTRATION_MAP_PANEL_MIN_ZOOM,
  },
  zenrin: {
    layerName: ZENRIN_BLUE_MAP_LAYER_NAME,
    minZoom: ZENRIN_BLUE_MAP_MIN_ZOOM,
  },
};
